import { SlideNumberProps } from './types';

export const SlideNumber = ({ currentSlideNumber, totalSlides }: SlideNumberProps) => (
    <div className="bg-primary/80 rounded-s grid grid-flow-col auto-cols-fr gap-x-px items-center p-3">
        <span className="relative text-right pr-2 after:absolute after:top-0 after:-right-px after:w-px after:h-full after:bg-current">
            {currentSlideNumber}
        </span>
        <span className="pl-2">{totalSlides}</span>
    </div>
);
